import React from 'react';
import { BookOpenIcon } from '@heroicons/react/outline';

const VerseOfTheDay = () => {
    return (
        <div className="min-h-screen bg-gray-100 text-gray-900">
            <main className="max-w-full mx-auto px-4 sm:px-6 lg:px-8 py-6">
                <div className="flex flex-col gap-4 mb-8">
                    <h1 className="text-3xl font-bold text-gray-900">Verse of the Day</h1>
                    <p className="text-gray-500">Daily inspiration from the Bible</p>
                </div>

                <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
                    <div className="border-b border-gray-200 px-5 py-4 sm:px-6">
                        <div className="flex items-center gap-3">
                            <div className="bg-indigo-500 rounded-full p-2">
                                <BookOpenIcon className="h-5 w-5 text-white" />
                            </div>
                            <h2 className="text-lg font-semibold text-gray-900">
                                Bible.com Verse of the Day
                            </h2>
                        </div>
                    </div>
                    <div className="p-0">
                        <iframe
                            title="Bible frame"
                            frameBorder="no"
                            height="600"
                            src="https://www.bible.com/verse-of-the-day"
                            width="100%"
                            className="rounded-b-lg"
                        />
                    </div>
                </div>
            </main>
        </div>
    );
};

export default VerseOfTheDay;
